export const accountMain = {
  sign_in: 'Sign In',
  or: 'or',
  sign_up: 'Create Account',
  account: 'Account',
  sign_up_or_sign_in: 'Sign Up or Create Account',
} as const
